import Alpine from "alpinejs";

const defaultPrompts = {
    1: "Man with a hat, 1950s",
    2: "Woman in a car, 1950s",
    3: "Woman in a powerful pose, 1950s",
};

Alpine.data("stablesForm", () => ({
    prompt: null,
    style: "default",
    abortController: null,
    imageData: "",
    showDownload: false,
    showLoader: false,
    errorText: "",
    show() {
        this.showLoader = true;
    },
    data() {
        const inputs = Array.from(this.$el.querySelectorAll("input, textarea"));
        return inputs.reduce((object, key) => ({ ...object, [key.name]: key.value }), {});
    },
    init() {
        this.$watch("style", (style) => {
            this.prompt = style;
        });
        this.$watch("imageData", () => {
            if (this.imageData !== "") {
                this.showDownload = true;
            }
        });
        this.$el.querySelector("input[type=file]").addEventListener("change", (event) => {
            event.target.setCustomValidity("");
            if (event.target.files[0].size > 2297152) {
                this.$nextTick(() => {
                    event.target.dispatchEvent(
                        new CustomEvent("fielderror", {
                            detail: "Das Bild ist zu gross, bitte lade ein kleineres Bild hoch.",
                            bubbles: true,
                            // Allows events to pass the shadow DOM barrier.
                            composed: true,
                            cancelable: true,
                        })
                    );
                    event.target.setCustomValidity("Das Bild ist zu gross, bitte lade ein kleineres Bild hoch.");
                });
            }
        });
        window.addEventListener("beforeunload", () => {
            if (this.abortController) this.abortController.abort();
        });
    },
    cancel() {
        if (this.abortController) this.abortController.abort();
    },
    async post() {
        if (!this.$el.querySelector("input[type=file]").files[0].size > 2297152) {
            return;
        }
        const endRequest = (interval) => {
            this.abortController = null;
            this.showLoader = false;
            clearInterval(interval);
        };

        if (this.abortController) this.abortController.abort();

        this.abortController = new AbortController();
        let requestError = null;

        this.showLoader = true;

        const requestID = await fetch("/stables", {
            method: "POST",
            body: new FormData(this.$el),
            signal: this.abortController.signal,
        })
            .then((data) => data.json())
            .then(({ id }) => id)
            .catch((error) => {
                requestError = error;
                this.showLoader = false;
            });

        if (requestError) {
            return;
        }

        this.abortController = new AbortController();

        const pollInterval = setInterval(async () => {
            await fetch("/stables/status/" + requestID, {
                signal: this.abortController.signal,
            })
                .then((data) => data.json())
                .then(({ status, output, error }) => {
                    if (status === "FAILED" && error) {
                        throw new Error();
                    }
                    if (status === "COMPLETED" && !!output) {
                        this.imageData = "data:image/jpeg;base64," + output;
                        endRequest(pollInterval);
                    }
                })
                .catch(() => {
                    this.errorText = "We're sorry but something went wrong, please try again with a different image!";
                    endRequest(pollInterval);
                });
        }, 2000);

        this.abortController.signal.addEventListener(
            "abort",
            () => {
                endRequest(pollInterval);
                fetch("/stables/cancel", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        id: requestID,
                    }),
                }).catch((error) => {
                    console.log(error);
                });
            },
            { once: true }
        );
    },
}));
